import React from 'react';
import { withPlaceholder } from 'HOC';
import {
  TransactionsColumnsType,
  mapData,
} from 'modules/UserTransactionsTable/UserTransactionsTable.columns';
import { PortfolioTransactionsType } from 'services/requests';
import { useGetAllAssets } from 'hooks/api/portfolio';
import RenderOpenOrdersTable from './components/RenderOpenOrdersTable';

const RenderOpenOrdersTableWithPlaceholders = withPlaceholder(RenderOpenOrdersTable);

const defaultColumns: TransactionsColumnsType[] = [
  'assetName',
  'type',
  'orderStatus',
  'date',
  'usdAmount',
  'assetAmount',
  'quotedPrice',
  'madeBy',
];

type Props = {
  columns?: TransactionsColumnsType[];
  transactionsData?: PortfolioTransactionsType;
  portfolioTransactionsLoading: boolean;
  isError: boolean;
  refetch: () => void;
  isRefetching: boolean;
};

const UserOpenOrdersTable: React.FC<Props> = ({
  columns = defaultColumns,
  transactionsData,
  portfolioTransactionsLoading,
  isError,
  refetch,
  isRefetching,
}) => {
  const { isLoading: allAssetsLoading } = useGetAllAssets();

  const isLoading = portfolioTransactionsLoading || allAssetsLoading;

  const items = mapData(transactionsData?.items);

  const onTransactionClick = () => {};

  return (
    <RenderOpenOrdersTableWithPlaceholders
      columns={columns}
      transactionsListData={transactionsData}
      items={items}
      onAssetClick={onTransactionClick}
      refetch={refetch}
      isRefetching={isRefetching}
      isLoading={isLoading}
      isError={isError}
      isData={true}
    />
  );
};

export default UserOpenOrdersTable;
